


















import Vue from 'vue'
import { Component } from 'vue-property-decorator'
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome"
import { faClock } from "@fortawesome/free-regular-svg-icons"
import TaskCard from "@/components/Gamification/TaskCard.vue"
import Typography from "@/components/Rain/Typography/Typography.vue"
import { TaskInfo, getMockData } from "@/entities/tasks"

@Component<TasksList>({
    components: {
        Typography,
        TaskCard,
        FontAwesomeIcon
    }
})
export default class TasksList extends Vue {
    private taskData!: TaskInfo
    private readonly faClock = faClock

    public beforeMount() {
        // TODO: grab data from API then delete mock data
        this.taskData = getMockData()
    }

    public get timeLeft() : string {
        // Temporarily static - Timer to be implemented in ticket WEB-9192
        return '23:00:00'
    }
}
